import { render, staticRenderFns } from "./link-icon-button.vue?vue&type=template&id=45ea1e62&lang=pug&"
import script from "./link-icon-button.vue?vue&type=script&lang=js&"
export * from "./link-icon-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports